import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { serializeClasses } from 'utilities/css';

const Path = styled.path`
  &.dark {
    fill: ${({ theme }) => theme.colors.text01};
    stroke: ${({ theme }) => theme.colors.text01};
  }
  fill: #2B73C7;
  stroke: #006FCF;
`;

export const FavoritedIcon = ({ dark, ...rest }) => {
  const pathClass = serializeClasses([dark && 'dark']);
  return (
    <svg {...rest} data-test-id="filled_heart" xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20">
      <Path className={pathClass} d="M16.113.5c-1.037.01-2.021.328-2.847.883-.827.556-1.495 1.35-1.896 2.31l-.461 1.103-.461-1.104c-.401-.96-1.069-1.753-1.896-2.309C7.727.83 6.742.51 5.705.5c-1.46.027-2.773.642-3.715 1.616C1.048 3.09.477 4.426.5 5.889c0 2.844 1.334 5.52 3.05 7.737C6.213 17.07 9.836 19.5 10.909 19.5c1.073 0 4.696-2.43 7.36-5.874 1.715-2.217 3.048-4.893 3.048-7.729.025-1.471-.546-2.806-1.49-3.781-.94-.974-2.253-1.59-3.714-1.616z" />
    </svg>
  );
};

FavoritedIcon.propTypes = {
  dark: PropTypes.bool
};

FavoritedIcon.defaultProps = {
  dark: false
};
